"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function FlatListSkeleton(_ref) {
  let {
    skeleton: Skeleton
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(Skeleton, null), /*#__PURE__*/_react.default.createElement(Skeleton, null), /*#__PURE__*/_react.default.createElement(Skeleton, null), /*#__PURE__*/_react.default.createElement(Skeleton, null), /*#__PURE__*/_react.default.createElement(Skeleton, null));
}
var _default = exports.default = FlatListSkeleton;